export enum TraccarUtilityActions {
  DoorOpen = 'DOOR_OPEN',
}
